import { ApiErrorI, ApiExistingTicketErrorI } from 'declarations/interfaces/errors';

export const getErrorMessage = (error: ApiErrorI | null) => {
  const messages = error?.data?.detail?.split(' | ');

  return messages && messages[0];
};

export const getValidationErrorMessage = (error: ApiErrorI | null) =>
  error?.data?.errors && Object.values(error?.data?.errors).flat(1).join('. ');

export const getExistingId = (error: ApiExistingTicketErrorI | null) => {
  return error?.data?.ExistingId ? error?.data?.ExistingId : null;
};
